<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
    <circle cx="8" cy="5.7041" r="4.25" stroke="#1B294A" stroke-width="1.5"/>
    <path d="M7.98845 17.5453L7.98824 17.5453L7.98798 17.5453L7.98486 17.5454L7.9702 17.5455L7.90854 17.5459C7.85354 17.546 7.77148 17.5458 7.66623 17.5444C7.4556 17.5416 7.15286 17.534 6.78892 17.5151C6.0581 17.4772 5.09386 17.3939 4.13802 17.215C3.16963 17.0337 2.27071 16.7648 1.63256 16.3864C1.00177 16.0123 0.75 15.6153 0.75 15.1742C0.75 13.8466 1.48074 12.582 2.78724 11.622C4.09336 10.6623 5.9339 10.0459 8 10.0459C10.0661 10.0459 11.9066 10.6623 13.2128 11.622C14.5193 12.582 15.25 13.8466 15.25 15.1742C15.25 15.6153 14.9982 16.0123 14.3674 16.3864C13.7293 16.7648 12.8304 17.0337 11.862 17.215C10.9061 17.3939 9.9419 17.4772 9.21108 17.5151C8.84714 17.534 8.5444 17.5416 8.33377 17.5444C8.22852 17.5458 8.14646 17.546 8.09146 17.5459L8.0298 17.5455L8.01514 17.5454L8.01202 17.5453L8.01176 17.5453L8.01155 17.5453H8.01153L8 17.5452L7.98847 17.5453H7.98845Z" stroke="#1B294A" stroke-width="1.5"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconPatientsSearch'
}
</script>
